
var userNameReg = /^[a-zA-Z][0-9a-zA-Z_]{3,23}$/;            // 用户名验证
var passwordReg = /^(?=.*[A-z])(?=.*\d).{6,16}$/;            // 密码验证
var emailReg = /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/;    // 邮箱验证
var phoneReg = /^(0|86|17951)?(13[0-9]|15[012356789]|16[6]|19[89]|17[01345678]|18[0-9]|14[579])[0-9]{8}$/;          // 手机正则
var nicknameReg = /^[\u4e00-\u9fa5A-Za-z0-9]{1,10}$/;        // 昵称正则
var eaNameReg = /^[\u4e00-\u9fa5A-Za-z0-9]{3,15}$/;          // EA名称正则
var realNameReg = /^[\u4e00-\u9fa5]{2,5}$/                   // 真实姓名 中文2-5字符
var verificationCode = /^[a-zA-Z0-9]{4}$/                    // 验证验证码格式是否正确
var graphicsCodeReg = /^[a-zA-Z0-9]{4}$/;                                  // 手机6位验证码校验
var phoneCodeReg = /\d{6}/;                                  // 手机6位验证码校验
// var titleReg = /^\w{5,10}$/;                                 // 文章标题校验
var httpHttpsReg = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/                                // http,https校验
var numReg = /^(\-|\+)?\d+(\.\d+)?$/                         // 数字校验
var emptyReg = /^[ ]+$/
var positiveNumReg = /^\+?[1-9][0-9]*$/
var volumeReg = /^(\-|\+)?\d+(\.\d{0,3})?$/



function graphicsCode(code) {
    return graphicsCodeReg.test(code);
}

function phoneCode(code) {
    return phoneCodeReg.test(code);
}

function validVerificationCode(code) {
    return verificationCode.test(code);
}

function validUserName(userName) {
    return userNameReg.test(userName);
}

function validPassword(password){
	return passwordReg.test(password);
}

function validEmail(email){
	return emailReg.test(email);
}

function validPhone(tel){
	return phoneReg.test(tel);
}

function validNickname(nickname){
    return nicknameReg.test(nickname);
}

function validEaName(eaName){
    return eaNameReg.test(eaName);
}

function validRealName(realName){       // 验证真实姓名
    return realNameReg.test(realName)
}

function httpReg(http){
    return httpHttpsReg.test(http);
}
// function validTitle(title){
//     return titleReg.test(title)
// }
function numCodeReg(num){
    return numReg.test(num);
}

function emptyContentReg(str){
    return emptyReg.test(str);
}

function positiveNumberReg(str){
    return positiveNumReg.test(str);
}

function tradeVolumeReg(str){
    return volumeReg.test(str);
}

module.exports = {
    validUserName:validUserName,
    validPassword:validPassword,
    validEmail:validEmail,
    validPhone:validPhone,
    validNickname: validNickname,
    validEaName: validEaName,
    validRealName:validRealName,
    validVerificationCode:validVerificationCode,
    phoneCode:phoneCode,
    httpReg:httpReg,
    numCodeReg:numCodeReg,
    // validTitle:validTitle,
    emptyContentReg:emptyContentReg,
    positiveNumberReg:positiveNumberReg,
    tradeVolumeReg:tradeVolumeReg,
    graphicsCode:graphicsCode
}



// WEBPACK FOOTER //
// ./src/service/common/reg.js